import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import { ServiceIcon } from 'components/common/ServiceIcon'

const Service = ({
  name,
  // listPrice,
  mainImageUrl,
  iconName
}) =>
  <Wrapper>
    <ImageWrapper>
      <ServiceIcon iconName={ iconName } />
    </ImageWrapper>
    <RightBlock>
      <Name>{ name }</Name>
      {/* Services will not have pricing for phase 1  */}
      {/* { listPrice > 0 && <Price>{ `$${listPrice}` }</Price> } */}
    </RightBlock>
  </Wrapper>

Service.propTypes = {
  // listPrice: PropTypes.number,
  iconName: PropTypes.string,
  mainImageUrl: PropTypes.string,
  name: PropTypes.string
}

export default Service

const Wrapper = styled.div`
  ${Mixin.responsive('padding', '0 0 0 168px', '0')}
  ${Mixin.clearFix()}
`

const RightBlock = styled.div`
  ${Mixin.responsive('float', 'left', 'none')}
`

// const Price = styled.span`
//   margin-right: 10px;
//   color: ${Theme.colors.sub_grey};
//   ${Mixin.font.OpenSans(14, 600, 19)}
//   ${Media.mobile`
//     &:last-child {
//       display: block;
//     }
//   `}
// `

const Name = styled.div`
  text-align: left;
  color: ${Theme.colors.black};
  ${Mixin.font.GothamBold(18)}
`

const ImageWrapper = styled.div`
  float: left;
  position: relative;
  text-align: center;
  border: 1px solid ${Theme.colors.light_grey};
  ${Mixin.responsive('width', '144px', '60px')}
  ${Mixin.responsive('height', '144px', '60px')}
  ${Mixin.responsive('margin', '0 0 5px -168px', '0 16px 0 0')}
  ${Mixin.middle()}
`
